import type { RendererOption } from './project-response-renderer.type';

const RENDERERS_WITHOUT_VOICE_ANSWER = new Set<RendererOption>(['matrix']);

export const resolveRenderMobileView = (
  renderMobileView: boolean | undefined,
  isDesktop: boolean
): boolean => (renderMobileView !== undefined ? renderMobileView : !isDesktop);

export const isVoiceAnswerable = (
  type: RendererOption | null | undefined
): boolean => !(type && RENDERERS_WITHOUT_VOICE_ANSWER.has(type));

export const isVoiceComposerActive = (
  responseMode: string | undefined,
  type: RendererOption | null | undefined
): boolean => responseMode === 'voice' && isVoiceAnswerable(type);
